module.exports = __webpack_public_path__ + "static/img/btn-py-EN-NON.1281fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/btn-py-EN-NON.png
// module id = AXAS
// module chunks = 1